<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-4"><em>Abbreviations</em></h1>
<table>
<tbody>
<tr>
<td class="td25"><p class="t-left">1 Clem.</p></td>
<td class="td70"><p class="t-left">1 Clement</p></td>
</tr>
<tr>
<td><p class="t-left">AB</p></td>
<td><p class="t-left">Anchor (Yale) Bible Commentary</p></td>
</tr>
<tr>
<td><p class="t-left"><em>ABD</em></p></td>
<td><p class="t-left"><em>Anchor Bible Dictionary</em>. Edited by David Noel Freedman. 6 vols. New York: Doubleday, 1992</p></td>
</tr>
<tr>
<td><p class="t-left">ABRL</p></td>
<td><p class="t-left">Anchor Bible Reference Library</p></td>
</tr>
<tr>
<td><p class="t-left"><em>Ant</em>.</p></td>
<td><p class="t-left">Josephus, <em>Jewish Antiquities</em></p></td>
</tr>
<tr>
<td><p class="t-left">ANTC</p></td>
<td><p class="t-left">Abingdon New Testament Commentaries</p></td>
</tr>
<tr>
<td><p class="t-left">BDAG</p></td>
<td><p class="t-left">Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. <em>Greek-English Lexicon of the New Testament and Other Early Christian Literature</em>. 3rd ed. Chicago: University of Chicago Press, 2000 (Danker-Bauer-Arndt-Gingrich)</p></td>
</tr>
<tr>
<td><p class="t-left">BDB</p></td>
<td><p class="t-left">Brown, Francis, S. R. Driver, and Charles A. Briggs. <em>A Hebrew and English Lexicon of the Old Testament</em>. Oxford: Clarendon, 1907.</p></td>
</tr>
<tr>
<td><p class="t-left">BECNT</p></td>
<td><p class="t-left">Baker Exegetical Commentary on the New Testament</p></td>
</tr>
<tr>
<td><p class="t-left">BHGNT</p></td>
<td><p class="t-left">Baylor Handbook on the Greek New Testament</p></td>
</tr>
<tr>
<td><p class="t-left">BibInt</p></td>
<td><p class="t-left">Biblical Interpretation Series</p></td>
</tr>
<tr>
<td><p class="t-left"><em>BJRL</em></p></td>
<td><p class="t-left"><em>Bulletin of the John Rylands University Library of Manchester</em></p></td>
</tr>
<tr>
<td><p class="t-left">BNTC</p></td>
<td><p class="t-left">Black’s New Testament Commentaries</p></td>
</tr>
<tr>
<td><p class="t-left">BSac</p></td>
<td><p class="t-left"><em>Bibliotheca Sacra</em></p></td>
</tr>
<tr>
<td><p class="t-left">BST</p></td>
<td><p class="t-left">Bible Speaks Today</p></td>
</tr>
<tr>
<td><p class="t-left">BZNW</p></td>
<td><p class="t-left">Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft</p></td>
</tr>
<tr>
<td><p class="t-left"><em>C. Ap.</em></p></td>
<td><p class="t-left">Josephus, <em>Contra Apionem</em></p></td>
</tr>
<tr>
<td><p class="t-left">ca.</p></td>
<td><p class="t-left">circa</p></td>
</tr>
<tr>
<td><p class="t-left"><em>CBQ</em></p></td>
<td><p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td><p class="t-left">ch(s).</p></td>
<td><p class="t-left">chapter(s)</p></td>
</tr>
<tr>
<td><p class="t-left"><em>CPR</em></p></td>
<td><p class="t-left"><em>Corpus Papyrorum Raineri.</em> Vienna: Hollinek, 1976–.</p></td>
</tr>
<tr>
<td><p class="t-left">CSB</p></td>
<td><p class="t-left">Christian Standard Bible</p></td>
</tr>
<tr>
<td><p class="t-left"><em>CTR</em></p></td>
<td><p class="t-left"><em>Criswell Theological Review</em></p></td>
</tr>
<tr>
<td><p class="t-left"><em>CurBR</em></p></td>
<td><p class="t-left"><em>Currents in Biblical Research</em></p></td>
</tr>
<tr>
<td><p class="t-left"><em>De piet.</em></p></td>
<td><p class="t-left">Diotogenes, <em>De pietate</em></p></td>
</tr>
<tr>
<td><p class="t-left"><em>Dial.</em></p></td>
<td><p class="t-left">Tacitus, <em>Dialogus de oratoribus</em></p></td>
</tr>
<tr>
<td><p class="t-left"><em>DPL</em></p></td>
<td><p class="t-left"><em>Dictionary of Paul and His Letters</em>. Edited by Gerald F. Hawthorne and Ralph P. Martin. Downers Grove, IL: InterVarsity Press, 1993</p></td>
</tr>
<tr>
<td><p class="t-left">EGGNT</p></td>
<td><p class="t-left">Exegetical Guide to the Greek New Testament</p></td>
</tr>
<tr>
<td><p class="t-left">esp.</p></td>
<td><p class="t-left">especially</p></td>
</tr>
<tr>
<td><p class="t-left">ESV</p></td>
<td><p class="t-left">English Standard Version</p></td>
</tr>
<tr>
<td><p class="t-left">FRLANT</p></td>
<td><p class="t-left">Forschungen zur Religion und Literatur des Alten und Neuen Testaments</p></td>
</tr>
<tr>
<td><p class="t-left"><em>Hist.</em></p></td>
<td><p class="t-left">Polybius, <em>Histories</em></p></td>
</tr>
<tr>
<td><p class="t-left">HThKNT</p></td>
<td><p class="t-left">Herders Theologischer Kommentar zum Neuen Testament</p></td>
</tr>
<tr>
<td><p class="t-left">IBC</p></td>
<td><p class="t-left">Interpretation: A Bible Commentary for Teaching and Preaching</p></td>
</tr>
<tr>
<td><p class="t-left"><em>Id.</em></p></td>
<td><p class="t-left"><em>Theocritus, Idylls</em></p></td>
</tr>
<tr>
<td><p class="t-left">ICC</p></td>
<td><p class="t-left">International Critical Commentary on the Holy Scriptures of the Old and New Testaments</p></td>
</tr>
<tr>
<td><p class="t-left">IVPNTC</p></td>
<td><p class="t-left">InterVarsity Press New Testament Commentary Series</p></td>
</tr>
<tr>
<td><p class="t-left"><em>JBL</em></p></td>
<td><p class="t-left"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td><p class="t-left"><em>JETS</em></p></td>
<td><p class="t-left"><em>Journal of the Evangelical Theological Society</em></p></td>
</tr>
<tr>
<td><p class="t-left"><em>JSNT</em></p></td>
<td><p class="t-left"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td><p class="t-left">JSNTSup</p></td>
<td><p class="t-left">Journal for the Study of the New Testament Supplement Series</p></td>
</tr>
<tr>
<td><p class="t-left"><em>JTS</em></p></td>
<td><p class="t-left"><em>Journal of Theological Studies</em> NS</p></td>
</tr>
<tr>
<td><p class="t-left"><em>J.W.</em></p></td>
<td><p class="t-left">Josephus, <em>Jewish War</em></p></td>
</tr>
<tr>
<td><p class="t-left">KEK</p></td>
<td><p class="t-left">Kritisch-exegetischer Kommentar über das Neue Testament (Meyer-Kommentar)</p></td>
</tr>
<tr>
<td><p class="t-left">KJV</p></td>
<td><p class="t-left">King James Version</p></td>
</tr>
<tr>
<td><p class="t-left">L&amp;N</p></td>
<td><p class="t-left">Louw, Johannes P., and Eugene A. Nida, eds. <em>Greek-English Lexicon of the New Testament: Based on Semantic Domains</em>. 2nd ed. New York: United Bible Societies, 1989</p></td>
</tr>
<tr>
<td><p class="t-left">LCL</p></td>
<td><p class="t-left">Loeb Classical Library</p></td>
</tr>
<tr>
<td><p class="t-left">LSJ</p></td>
<td><p class="t-left">Liddell, Henry George, Robert Scott, and Henry Stuart Jones. <em>A Greek-English Lexicon</em>. 9th ed. with revised supplement. Oxford: Clarendon, 1996</p></td>
</tr>
<tr>
<td><p class="t-left">LXX</p></td>
<td><p class="t-left">Septuagint</p></td>
</tr>
<tr>
<td><p class="t-left"><em>MM</em></p></td>
<td><p class="t-left">Moulton, James H., and George Milligan. <em>The Vocabulary of the Greek Testament</em>. London, 1930. Repr. Peabody, MA: Hendrickson, 1997</p></td>
</tr>
<tr>
<td><p class="t-left">NA<sup>28</sup></p></td>
<td><p class="t-left"><em>Novum Testamentum Graece</em>, Nestle-Aland, 28th ed.</p></td>
</tr>
<tr>
<td><p class="t-left">NASB</p></td>
<td><p class="t-left">New American Standard Bible</p></td>
</tr>
<tr>
<td><p class="t-left">NCB</p></td>
<td><p class="t-left">New Century Bible</p></td>
</tr>
<tr>
<td><p class="t-left">NET</p></td>
<td><p class="t-left">New English Translation</p></td>
</tr>
<tr>
<td><p class="t-left">NICNT</p></td>
<td><p class="t-left">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td><p class="t-left"><em>NIDNTTE</em></p></td>
<td><p class="t-left">Silva, Moisés, ed. <em>New International Dictionary of New Testament Theology and Exegesis.</em> 2nd ed. 5 vols. Grand Rapids: Zondervan, 2014</p></td>
</tr>
<tr>
<td><p class="t-left">NIV</p></td>
<td><p class="t-left">New International Version</p></td>
</tr>
<tr>
<td><p class="t-left">NLT</p></td>
<td><p class="t-left">New Living Translation</p></td>
</tr>
<tr>
<td><p class="t-left"><em>NovT</em></p></td>
<td><p class="t-left"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td><p class="t-left">NovTSup</p></td>
<td><p class="t-left">Supplements for Novum Testamentum</p></td>
</tr>
<tr>
<td><p class="t-left">NRSV</p></td>
<td><p class="t-left">New Revised Standard Version</p></td>
</tr>
<tr>
<td><p class="t-left">NS</p></td>
<td><p class="t-left">new series</p></td>
</tr>
<tr>
<td><p class="t-left">NSBT</p></td>
<td><p class="t-left">New Studies in Biblical Theology</p></td>
</tr>
<tr>
<td><p class="t-left">NTL</p></td>
<td><p class="t-left">New Testament Library</p></td>
</tr>
<tr>
<td><p class="t-left"><em>NTS</em></p></td>
<td><p class="t-left"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td><p class="t-left">OECS</p></td>
<td><p class="t-left">Oxford Early Christian Studies</p></td>
</tr>
<tr>
<td><p class="t-left">PG</p></td>
<td><p class="t-left">Patrologia Graeca. Edited by Jacques-Paul Migne. 162 vols. 1857–1886</p></td>
</tr>
<tr>
<td><p class="t-left"><em>PGM</em></p></td>
<td><p class="t-left">Preisendanz, Karl, ed. and trans. <em>Papyri Graecae Magicae: Die griechischen Zauberpapyri</em>. 3 vols. Leipzig: Teubner, 1928–1941</p></td>
</tr>
<tr>
<td><p class="t-left"><em>Phil.</em></p></td>
<td><p class="t-left">Polycarp, <em>Ad Philippenses</em></p></td>
</tr>
<tr>
<td><p class="t-left">PNTC</p></td>
<td><p class="t-left">Pillar New Testament Commentary</p></td>
</tr>
<tr>
<td><p class="t-left">SBG</p></td>
<td><p class="t-left">Studies in Biblical Greek</p></td>
</tr>
<tr>
<td><p class="t-left">SBLStBL</p></td>
<td><p class="t-left">Society of Biblical Literature Studies in Biblical Literature</p></td>
</tr>
<tr>
<td><p class="t-left">SNTSMS</p></td>
<td><p class="t-left">Society for New Testament Studies Monograph Series</p></td>
</tr>
<tr>
<td><p class="t-left">SP</p></td>
<td><p class="t-left">Sacra Pagina</p></td>
</tr>
<tr>
<td><p class="t-left"><em>TDNT</em></p></td>
<td><p class="t-left"><em>Theological Dictionary of the New Testament</em>. Edited by Gerhard Kittel and Gerhard Friedrich. Translated by Geoffrey W. Bromiley. 10 vols. Grand Rapids: Eerdmans, 1964–1976</p></td>
</tr>
<tr>
<td><p class="t-left">TENTS</p></td>
<td><p class="t-left">Texts and Editions for New Testament Study</p></td>
</tr>
<tr>
<td><p class="t-left"><em>TJ</em></p></td>
<td><p class="t-left"><em>Trinity Journal</em></p></td>
</tr>
<tr>
<td><p class="t-left">TNTC</p></td>
<td><p class="t-left">Tyndale New Testament Commentaries</p></td>
</tr>
<tr>
<td><p class="t-left">WBC</p></td>
<td><p class="t-left">Word Biblical Commentary</p></td>
</tr>
<tr>
<td><p class="t-left">WEB</p></td>
<td><p class="t-left">World English Bible</p></td>
</tr>
<tr>
<td><p class="t-left">WUNT</p></td>
<td><p class="t-left">Wissenschaftliche Untersuchungen zum Neuen Testament</p></td>
</tr>
<tr>
<td><p class="t-left"><em>ZKT</em></p></td>
<td><p class="t-left"><em>Zeitschrift für katholische Theologie</em></p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Abbreviations.vue?139138a5